export const getLoy3MembershipInfo = state => state.sandos4U.membershipUser;
export const getLoy3Transactions = state => state.sandos4U.transactions;
export const getCart = state => state.sandos4U.cart;
